import { TreeModel } from '@huntsman-cancer-institute/angular-tree-component';
import { ITreeNode, TreeNode } from '@huntsman-cancer-institute/angular-tree-component/lib/defs/api';

export interface ITreeViewerNode<T> extends ITreeNode {
    id: string;
    name: string;
    children: ITreeViewerNode<T>[];
    disabled: boolean;
    data: T;
    type?: NodeTypes;
}

export type TreeViewerNode<T> = Partial<ITreeViewerNode<T>>;

export enum NodeTypes {
    Regular = 'REGULAR',
    LoadMore = 'LOADMORE'
}
export interface NodeOffset {
    [key: string]: {
        offset: number;
    };
}

export interface TreeEvent {
    eventName: string;
    node: TreeNode;
    treeModel: TreeModel;
}

export {
    ITreeOptions,
    TREE_ACTIONS,
    TreeComponent,
    TreeModel,
    TreeNode
} from '@huntsman-cancer-institute/angular-tree-component';
export { ITreeNode } from '@huntsman-cancer-institute/angular-tree-component/lib/defs/api';
